module.exports = __webpack_public_path__ + "static/media/search-fill.dff58bbc.svg";